
import { BroadcastEvent } from "@enums/BroadcastEvent";
import * as angular from "angular";
import { ConstantsService } from "@services/constantsService";
import "./popup.scss";

interface IPopupPositionInfo {
    top: number;
    left: number;
    yOverrun: number;
}

export interface IPopupBindings extends angular.IComponentController {
    mouseEvent: MouseEvent;
    popupLocation: google.maps.Point;
    arrowPosition: "top" | "bottom" | "left" | "right";
    showOnRight: boolean;

    showDelay: number;
    hideDelay: number;

    minShowTime: number;
    onClose: () => void;
}

class PopupComponentController implements angular.IComponentController, IPopupBindings {

    mouseEvent: MouseEvent;
    previousMouseEvent: MouseEvent;
    popupLocation: google.maps.Point;
    arrowPosition: "top" | "bottom" | "left" | "right";
    showOnRight: boolean;

    showDelay: number;
    hideDelay: number;

    minShowTime: number;

    onClose: () => void;

    uniqueCode: string;
    transEl: JQuery;

    requireSameElement = true;
    showCenter: boolean;

    isMobile: boolean;

    static isDisplayed: boolean;

    static popupPosition: IPopupPositionInfo;
    static previousPopupPosition: IPopupPositionInfo;

    static popupWrapper: JQuery;

    static showPromise: angular.IPromise<any>;
    static hidePromise: angular.IPromise<any>;

    static lastUniqueCodeDisplayed: string;

    readonly popupClassName = "show-popup";
    static $inject = ["$scope", "$element", "$transclude", "$timeout", "constantsService"];

    constructor(
        private readonly $scope: angular.IScope,
        private readonly $element: angular.IAugmentedJQuery,
        private readonly $transclude: angular.ITranscludeFunction,
        private readonly $timeout: angular.ITimeoutService,
        private readonly constantsService: ConstantsService) {
        this.uniqueCode = Math.random().toString(36).substring(2) + Date.now().toString(36);
    }

    $onInit() {
        this.isMobile = this.constantsService.getIsMobile();
        if (this.isMobile) {
            this.showCenter = true;
        }

        PopupComponentController.popupWrapper = angular.element("popup-wrapper");
        //if (this.popupWrapper.length == 0) {
        //    this.popupWrapper = angular.element("<popup-wrapper></popup-wrapper>");
        //    angular.element(document.body).append(this.popupWrapper);
        //}

        this.showDelay = this.showDelay || 350;
        this.hideDelay = this.hideDelay || 350;
        // Todo: Make this only happen once per static instance as we are duplicating handlers...
        this.registerHandlers();

        this.$scope.$on(BroadcastEvent.hidePopup, () => {
            this.hidePopup(true);
        });
    }

    $onDestroy() {
        if (this.transEl) {
            this.transEl.remove();
        }

        this.unregisterHandlers();
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {

        if (!PopupComponentController.popupWrapper) {
            return;
        }

        if (this.requireSameElement && this.previousMouseEvent) {
            if (!PopupComponentController.isDisplayed) {

                // If we are not the same target object, then abort the show
                if (this.getEventTargetElement(this.mouseEvent, true) != this.getEventTargetElement(this.previousMouseEvent, true)) {
                    this.hidePopup();
                }
            }
        }

        this.arrowPosition = this.arrowPosition || "left";

        if (PopupComponentController.lastUniqueCodeDisplayed != this.uniqueCode) {

            var $$element = PopupComponentController.popupWrapper;

            this.$transclude((transEl, transScope: any) => {

                $$element.empty();

                // Now append transcluded element to your element
                this.transEl = transEl;
                $$element.append(transEl);
            });

            PopupComponentController.lastUniqueCodeDisplayed = this.uniqueCode;

            this.updateArrowPosition();
        }

        if (this.mouseEvent || this.popupLocation) {
            this.updatePopupPosition();

            this.showPopup();
        }
        else {
            this.hidePopup();
        }

        this.previousMouseEvent = this.mouseEvent;
    }

    // ----------------------------------------

    private updatePopupPosition() {
        PopupComponentController.previousPopupPosition = PopupComponentController.popupPosition;

        if (this.mouseEvent) {
            var element = this.getEventTargetElement(this.mouseEvent);
            PopupComponentController.popupPosition = this.getElementPositionInfo(element);
        }

        if (this.popupLocation) {
            PopupComponentController.popupPosition = PopupComponentController.popupPosition || { left: 0, top: 0, yOverrun: 0 };
            PopupComponentController.popupPosition.left = this.popupLocation.x;
            PopupComponentController.popupPosition.top = this.popupLocation.y;

            // Now adjust for arrow location - lets just assume bottom for now to make things easier
            //const popupWidth = this.popupWrapper.width();
            //const popupHeight = this.popupWrapper.height();
            //this.popupPosition.left += popupWidth / 2;
            //this.popupPosition.top -= popupHeight;
        }

        if (!PopupComponentController.previousPopupPosition || PopupComponentController.previousPopupPosition.top != PopupComponentController.popupPosition.top || PopupComponentController.previousPopupPosition.left != PopupComponentController.popupPosition.left) {
            PopupComponentController.popupWrapper[0].style.left = PopupComponentController.popupPosition.left + 'px';
            PopupComponentController.popupWrapper[0].style.top = PopupComponentController.popupPosition.top + 'px';
        }

        this.updateOverrunClass();
    }

    private updateOverrunClass() {
        var classes = PopupComponentController.popupWrapper[0].className.split(" ");

        var classesToKeep: string[] = [];

        classes.forEach(c => {
            if (!c.startsWith("ao-")) {
                classesToKeep.push(c);
            }
        });

        if (PopupComponentController.popupPosition.yOverrun > 0) {
            classesToKeep.push(`ao-${PopupComponentController.popupPosition.yOverrun}`);
        }

        PopupComponentController.popupWrapper[0].className = classesToKeep.join(" ");
    }

    private updateArrowPosition() {

        PopupComponentController.popupWrapper.removeClass("top");
        PopupComponentController.popupWrapper.removeClass("bottom");
        PopupComponentController.popupWrapper.removeClass("left");
        PopupComponentController.popupWrapper.removeClass("right");
        PopupComponentController.popupWrapper.addClass(this.arrowPosition);
    }

    private showPopup() {
        this.cancelHide();

        if (PopupComponentController.isDisplayed) {
            return;
        }

        if (PopupComponentController.showPromise) {
            return;
        }

        PopupComponentController.showPromise = this.$timeout(() => {
            PopupComponentController.popupWrapper.addClass(this.popupClassName);
            this.updateArrowPosition();

            PopupComponentController.showPromise = null;
            PopupComponentController.isDisplayed = true;

        }, this.showDelay);
    }

    private hidePopup(ignoreDelay = false) {
        this.cancelShow();
        this.cancelHide();

        if (!PopupComponentController.isDisplayed) {
            return;
        }

        var delay = ignoreDelay ? 0 : this.hideDelay;

        PopupComponentController.hidePromise = this.$timeout(() => {
            PopupComponentController.popupWrapper.removeClass(this.popupClassName);

            // All animations are 0.3s so gives the transition chance to occur BEFORE we call OnClose
            this.$timeout(() => {
                if (this.onClose) {
                    PopupComponentController.isDisplayed = false;
                    this.onClose();
                }
            }, 300);
        }, delay);
    }


    private cancelShow() {
        if (PopupComponentController.showPromise) {
            this.$timeout.cancel(PopupComponentController.showPromise);
            PopupComponentController.showPromise = null;
        }
    }

    private cancelHide() {
        if (PopupComponentController.hidePromise) {
            this.$timeout.cancel(PopupComponentController.hidePromise);
            PopupComponentController.hidePromise = null;
        }
    }

    private getElementPositionInfo(targetElement: HTMLElement): IPopupPositionInfo {
        if (!targetElement || targetElement?.children[0]?.nodeName == 'HTML') {
            console.warn("getElementPositionInfo - No Target Element provided");
            return null;
        }

        var elementHeight = Math.max(PopupComponentController.popupWrapper[0].offsetHeight, PopupComponentController.popupWrapper[0].scrollHeight);

        const padding = 10;
        const leftPadding = 8;

        var rect = targetElement.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        var position: IPopupPositionInfo = {
            top: rect.top + scrollTop,
            left: rect.left + scrollLeft - leftPadding,
            yOverrun: 0
        }

        if (this.showOnRight) {
            position.left = rect.left + targetElement.offsetWidth + leftPadding;

            PopupComponentController.popupWrapper.addClass("show-on-right");
        }
        else {
            PopupComponentController.popupWrapper.removeClass("show-on-right");
        }

        const defaultTriangleOffset = 30;

        // 30 is the default triangle position for the dialog
        if (rect.height < defaultTriangleOffset) {

            position.top -= defaultTriangleOffset - rect.height;
        }

        if (this.showCenter) {
            position.left = 45;
            position.top = rect.top + 5;
            PopupComponentController.popupWrapper.addClass("show-on-right");
        }

        // Todo: Make sure AO only gets added once (i.e. cache previous)
        // Make sure things dont happen if we are not visible, i.e. class changes
        // Dont re-add any class, including show-popup if already added

        position.yOverrun = position.top + elementHeight - document.documentElement.scrollHeight;

        if (position.yOverrun > 0) {

            position.top -= position.yOverrun + padding;

            // Round to nearest 5
            position.yOverrun = Math.ceil(position.yOverrun / 5) * 5;

            while (position.yOverrun + defaultTriangleOffset + 10 > elementHeight) {
                position.yOverrun -= 5;
            }
        }

        return position;
    }

    private getEventTargetElement(event: MouseEvent, startAtLeafNode = false): HTMLElement {
        if (!event) {
            return null;
        }

        if (startAtLeafNode) {
            return (event.target || event.currentTarget) as HTMLElement;
        }

        return (event.currentTarget || event.target) as HTMLElement;
    }

    private registerHandlers() {
        document.body.addEventListener('click', this.bodyClickHandler);

        PopupComponentController.popupWrapper[0].addEventListener('mouseenter', this.mouseEnterHandler);
        PopupComponentController.popupWrapper[0].addEventListener('mouseleave', this.mouseLeaveHandler);
    }

    private unregisterHandlers() {
        document.body.removeEventListener('click', this.bodyClickHandler);
        PopupComponentController.popupWrapper[0].removeEventListener('mouseenter', this.mouseEnterHandler);
        PopupComponentController.popupWrapper[0].removeEventListener('mouseleave', this.mouseLeaveHandler);
    }

    private bodyClickHandler = (event: MouseEvent) => {
        var element = this.getEventTargetElement(event, true);

        if (!element) {
            return;
        }

        while (element.parentElement) {
            if (element.parentElement.nodeName.toLocaleLowerCase() == "popup-wrapper") {
                return;
            }

            element = element.parentElement;
        }

        this.hidePopup(true);
    }

    private mouseEnterHandler = (event: MouseEvent) => {
        this.cancelHide();
    }

    private mouseLeaveHandler = (event: MouseEvent) => {
        this.hidePopup();
    }
}

export class PopupComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    transclude?: boolean | { [slot: string]: string };

    constructor() {
        this.bindings = {
            mouseEvent: "<",
            popupLocation: "<",

            arrowPosition: "@",
            requireSameElement: "@",
            showOnRight: "<",

            showDelay: "<",
            hideDelay: "<",
            onClose: "&"
        };

        this.transclude = true;

        this.controller = PopupComponentController;
    }
}
